<script setup lang="ts">
defineProps<{
    title: string
}>()
</script>

<template>
    <div>
        <!-- font-medium grow text-body-2 text-primary -->
        <span class="block w-full mb-4 font-medium text-h6 text-grayscale-900">{{ title }}</span>

        <slot />
    </div>
</template>
